<template>
    <el-popover
        :placement="placement"
        :title="title"
        :width="width"
        :trigger="trigger"
        :index="index"
        :handleBlur="handleBlur"
    >
        <div class="input_popover_wrap">
            <el-input v-model="value" placeholder="" size="mini" @blur="handleBlur(value, index)"></el-input>
        </div>
        <slot slot="reference">
            <span>value</span>
        </slot>
    </el-popover>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    props: {
        placement: {
            type: String,
            default: "top",
        },
        title: {
            type: String,
            default: "Title",
        },
        width: {
            type: Number,
            default: 200,
        },
        trigger: {
            type: String,
            default: "click",
        },
        index: {
            type: Number,
            default: 0,
        },
        row: {
            type: Object,
            default: {},
        },
        value: {
            type: String,
            default: '',
        },
        handleBlur: {
          type: Function,
          default: () => {}
        }
    },
    methods: {
        // handleBlur() {
        //     this.$emit("handleInputBlur", {
        //         row: this.row,
        //         index: this.index,
        //         value,
        //     });
        // },
    },
};
</script>

<style lang="scss">
.input_popover_wrap {
    display: flex;
    justify-content: space-around;
    .el-input {
        // width: 80px;
        // .el-input-group__prepend {
        //     padding: 0 5px;
        // }
        .el-input__inner {
            padding: 0 5px;
        }
    }
}
</style>